import React, {useState} from 'react';
import {GetStaticProps} from 'next';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import styles from './audioBook.module.scss';

import {useRouter} from 'next/router';
import {audioBookService} from "@/services/audioBookService";
import AudiobookPlayer from "@/components/audiobook/AudiobookPlayer";
import {orderService} from "@/firebase/orderService";
import FormatIcons from "@/components/ui/FormatIcons";

export default function audioBook({content, audiobookDictionary}: any) {
    // const { headline, about, freeThinking, callToBuy } = content;
    const router = useRouter();
    const dir = router.locale === 'he' ? 'rtl' : 'ltr';
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loginFailed, setLoginFailed] = useState(false);
    const [authenticated, setAuthenticated] = useState(true);
    let audioBookPassword = localStorage.getItem('audioBookPassword');

    if (audioBookPassword !== null) {
        try {
            audioBookPassword = JSON.parse(audioBookPassword);
        } catch (error) {
            // Handle JSON parse error, if necessary
        }
    }


    const login = async () => {
        try {
            debugger;
            // Implement your authentication logic here.
            // If authentication is successful, set authenticated to true.
            // Example: Authenticate with a server or use Firebase Auth.
            let email = username;
            const login = await orderService.getOrdersByEmail(email);
            const userInfo = login[0];
            const {audioBook, audioBookPassword} = userInfo;
            debugger;
            if (audioBook && audioBookPassword === password) {
                setAuthenticated(true);
                localStorage.setItem('audioBookPassword', JSON.stringify(password));


            } else {
                setAuthenticated(false);
                setLoginFailed(true);

            }
            // authenticated=true;
            // let x = authenticated;
            // debugger;
        } catch (error) {
            console.error('Authentication error: ', error);
            setLoginFailed(true);
            setAuthenticated(false);

        }
    };
    // debugger;
    // let authenticated=true;
    return (
        // <AuthProvider>

        <main

            dir={dir}
        >
            <div dir="lrt" className={styles['format-display']}>
                {/*<FormatIcons show={'audiobook'}/>*/}
                <center>
                    <img src={'https://storage.googleapis.com/images-freethinking/Image_6_twsjo8.webp'} alt="free thinking"/>

                </center>
            </div>
            <div>


            </div>

            {(audioBookPassword != null ||
                authenticated) && audiobookDictionary && (


                <AudiobookPlayer audiobookId={"החופש לחשוב"} audiobookDictionary={audiobookDictionary}/>


            )}
            {(!audioBookPassword && !authenticated) && (<div>
                <center>
                    <div>
                        <input
                            type="text"
                            placeholder="אימייל"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                        <br></br>
                        <input
                            type="password"
                            placeholder="סיסמא"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />


                    </div>
                    {loginFailed && (<div>

                        <center>
                            <h2>סיסמא או אימייל שגוים , אנא נסה שנית</h2>
                        </center>
                    </div>)}
                </center>
                <br></br>
                <center>

                    <button className="primary-btn-blue" onClick={login}>התחבר</button>

                </center>
            </div>)
            }

        </main>
        // </AuthProvider>
    );
}

export const getStaticProps: GetStaticProps = async ({locale}) => {
    // const content = await webContentService.getPageContent(locale, 'aboutPage');
    const audiobookDictionary = await audioBookService.getAudioBookLinks(); // Fetch the dictionary
    // debugger;
    // const { authenticated } = useAuth();

    return {
        props: {
            audiobookDictionary,
            // authenticated,

            ...(await serverSideTranslations(locale ?? 'en', ['common', 'meta'])),
        },
        revalidate: 60,
    };
};
